import { useGlobalNotifier, useMessage } from "@vrf/fr-vrf-core-react";
import {
  FrVrfButton,
  FrVrfFooter,
  FrVrfMultipleLineInputField,
} from "@vrf/fr-vrf-web-components-react";
import React, { useEffect } from "react";
import { useCommentDialogState } from ".";
import { ApplicationMessageScreen } from "../../../messages";
import { usePageNavigation } from "../../../pages/use-page-navigation";
import { useUpdateTicket } from "../../../services/ticket";
import { createModal } from "../../modal";

export const CommentDialogContent = () => {
  const { showConfirmationDialog, showToast, errorMessages, resetUserError } =
    useGlobalNotifier();
  const { messageForScreen } = useMessage();
  const [dialogState, setDialogState] = useCommentDialogState();
  const [getUpdateTicketResponse, sendUpdateTicketRequest] = useUpdateTicket();
  const { moveToModalPage, closeModalPage, isModalPage } = usePageNavigation();

  const onInitialDisplayed = () => {
    moveToModalPage();
    resetUserError();
    const commentDescription =
      dialogState.selectedEvent === "srcComment"
        ? dialogState.ifList.projectTcktInfo.srcDsgnCmnt
        : dialogState.ifList.projectTcktInfo.dstDsgnCmnt;
    setDialogState((prevState) => ({
      ...prevState,
      commentDescription: commentDescription,
      isSaved: true,
    }));
  };
  useEffect(onInitialDisplayed, []);

  const onUpdateTicketResponse = () => {
    if (getUpdateTicketResponse) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      closeModalPage();
      setDialogState((prevState) => ({
        ...prevState,
        isShow: false,
      }));
      dialogState.onChangeSpreadsheetState(
        dialogState.commentDescription,
        getUpdateTicketResponse,
      );
    }
  };
  useEffect(onUpdateTicketResponse, [getUpdateTicketResponse]);

  const valueChangeHandle = (event: CustomEvent) => {
    const inputValue = event.detail.value;
    const isValid = event.detail.isValid;
    setDialogState((prevState) => ({
      ...prevState,
      commentDescription: inputValue,
      isSaved: false,
      formValidation: isValid,
    }));
  };

  const onClickCompleteInput = () => {
    resetUserError();
    const isSrc = dialogState.selectedEvent === "srcComment";
    const tcktId = isSrc
      ? dialogState.ifList.projectTcktInfo.srcDsgnTcktId
      : dialogState.ifList.projectTcktInfo.dstDsgnTcktId;
    if (!tcktId) {
      return;
    }
    sendUpdateTicketRequest({
      tcktId: tcktId,
      ifReqId: dialogState.ifList.project.ifReqId,
      cmnt: dialogState.commentDescription,
      updateDateTime: isSrc
        ? dialogState.ifList.projectTcktInfo.srcDsgnTcktUpdateDateTime
        : dialogState.ifList.projectTcktInfo.dstDsgnTcktUpdateDateTime,
    });
  };

  const onClickCancel = () => {
    if (dialogState.isSaved) {
      closeModalPage();
      setDialogState((prevState) => ({
        ...prevState,
        isShow: false,
        isSaved: true,
        formValidation: true,
      }));
      return;
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        closeModalPage();
        setDialogState((prevState) => ({
          ...prevState,
          isShow: false,
          isSaved: true,
          formValidation: true,
        }));
      },
    });
  };

  return (
    <>
      {createModal(
        "Input Comment",
        <div>
          <div>
            <FrVrfMultipleLineInputField
              labelContent="Description"
              placeholder="Please input..."
              content={dialogState.commentDescription}
              style={{
                "--vrf-multiple-line-input-field-label-width": "100px",
                "--vrf-multiple-line-input-field-input-height": "200px",
                "--vrf-multiple-line-input-field-input-width": "600px",
              }}
              clearButtonVisible={true}
              onInputValueChanged={valueChangeHandle}
              errorMessage={errorMessages(
                dialogState.fieldPath.cmnt,
                isModalPage(),
              )}
              constraint="Size(value, {min: 0, max: 256})"
            />
          </div>
          <FrVrfFooter>
            <FrVrfButton
              content="Cancel"
              theme="secondary"
              size="large"
              onClicked={onClickCancel}
            />
            <FrVrfButton
              content="Complete Input"
              theme="primary"
              size="large"
              onClicked={onClickCompleteInput}
              disabled={!dialogState.formValidation}
              authActId="comment_dialog.button.complete_input"
            />
          </FrVrfFooter>
        </div>,
        () => {},
        "small",
      )}
    </>
  );
};
